import { useQuery } from 'react-query';
import { getRequestHeaders, vake_api_server_url } from './helpers';
import { useAuth } from '../auth/AuthProvider';

export const useDetectFlagChange = (mmsi: string, timePoint: FlagChangeProps, mode: 'forward' | 'backward') => {
    const { timestamp, lat, lon } = timePoint;
    const { token } = useAuth();
    const url = `${vake_api_server_url}/flag_change?mmsi=${mmsi}&timestamp=${timestamp.toISOString()}&lat=${lat}&lon=${lon}&mode=${mode}`;
    return useQuery<FlagChangeResponse[]>(
        ['flagChange', mmsi, lon, lat, timestamp],
        async () => {
            const res = await fetch(url, {
                credentials: 'include',
                headers: getRequestHeaders(token),
            });

            if (!res.ok) {
                throw new Error(res.statusText);
            }
            return await res.json();
        },
        {
            staleTime: Infinity,
        }
    );
};
